module.exports = __webpack_public_path__ + "static/media/5.c1dcb348.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hairfront/5.png
// module id = 714
// module chunks = 0